import * as React from 'react'

export function RenaissanceIDPError(): React.ReactElement {
  return (
    <React.Fragment>
      The following Renaissance Configuration information is required to use Renaissance as the
      identify provider: <strong>Client ID</strong>, <strong>RPID</strong>,{' '}
      <strong>Base URL</strong>, <strong>RP Identifier</strong> and{' '}
      <strong>Platform set to RGP</strong>.
    </React.Fragment>
  )
}
